import { render, staticRenderFns } from "./FeeImportCOD.vue?vue&type=template&id=e42a8b6e&scoped=true&"
import script from "./FeeImportCOD.vue?vue&type=script&lang=js&"
export * from "./FeeImportCOD.vue?vue&type=script&lang=js&"
import style0 from "./FeeImportCOD.vue?vue&type=style&index=0&id=e42a8b6e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e42a8b6e",
  null
  
)

export default component.exports